import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Actions as ADMINACTIONS } from '../../../store/actions/adminActions';
import { selectStyles } from '../../utils/ReactSelectStyles';
import Breadcrumb from '../../Common/Breadcrumb';
import { AddButton } from '../../../styledComponents/GlobalStyle';
import _ from 'lodash';
import Select from 'react-select';
import { Tooltip } from '@mui/material';
import Modal from '@mui/material/Modal';
import { Waveform } from '@uiball/loaders';
import { adminPortalSelect } from '../../utils/ReactSelectStyles';

const items = [{ label: 'Audit Logs', link: '/admin/auditLogs' }];
const boxStyles = { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' };

// View Details Modal
const ViewDetailsModal = ({ open, handleClose, data }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className='modal-dialog' style={{ maxWidth: '90%', overflowX: 'auto' }}>
        <div className='modal-content'>
          <div className='modal-header'>
            <button onClick={handleClose} className='close'>
              &times;
            </button>
            <h4 className='modal-title'>View Details</h4>
          </div>
          <div className='modal-body' style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <div style={{ marginBottom: '20px' }}>
              <h4 className='modal-subtitle' style={{ fontWeight: 'bold' }}>
                Author
              </h4>
              <p>{data?.authorName || '<empty>'}</p>
              <p>{data?.authorID || '<empty>'}</p>
            </div>
            <hr />
            <div style={{ marginBottom: '20px' }}>
              <h4 className='modal-subtitle' style={{ fontWeight: 'bold' }}>
                Item ID
              </h4>
              <p>{data?.itemId || '<empty>'}</p>
            </div>
            <hr />
            <div style={{ marginBottom: '20px' }}>
              <h4 className='modal-subtitle' style={{ fontWeight: 'bold' }}>
                Change
              </h4>
              {data?.change === 'Added' && <span className='label label-success'>Added</span>}
              {data?.change === 'Deleted' && <span className='label label-danger'>Deleted</span>}
              {data?.change === 'Updated' && <span className='label label-warning'>Updated</span>}
            </div>
            <hr />
            <div style={{ marginBottom: '20px' }}>
              <h4 className='modal-subtitle' style={{ fontWeight: 'bold' }}>
                Table
              </h4>
              <p>{data?.table || '<empty>'}</p>
            </div>
            <hr />
            <div style={{ marginBottom: '20px' }}>
              <h4 className='modal-subtitle' style={{ fontWeight: 'bold' }}>
                Difference
              </h4>
              {/* Display the difference table according to the change */}
              <div style={{ overflowX: 'auto' }}>
                {data?.change === 'Updated' && (
                  <table className='table table-striped'>
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Old Value</th>
                        <th>New Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(data.diff).map(([field, diffEntry]) => {
                        let node = diffEntry;
                        while (
                          node &&
                          typeof node === 'object' &&
                          !Array.isArray(node) &&
                          !('__old' in node && '__new' in node)
                        ) {
                          const keys = Object.keys(node);
                          if (keys.length === 1) {
                            node = node[keys[0]];
                          } else {
                            break;
                          }
                        }

                        const oldRaw =
                          node && node.__old !== undefined
                            ? node.__old
                            : diffEntry && diffEntry.__old !== undefined
                            ? diffEntry.__old
                            : undefined;

                        const newRaw =
                          node && node.__new !== undefined
                            ? node.__new
                            : diffEntry && diffEntry.__new !== undefined
                            ? diffEntry.__new
                            : undefined;

                        const format = (v) => {
                          if (v == null) return '<empty>';
                          if (Array.isArray(v)) {
                            return v
                              .map((x) => (x !== null && typeof x === 'object' ? JSON.stringify(x) : String(x)))
                              .join(', ');
                          }
                          if (typeof v === 'object') {
                            return JSON.stringify(v);
                          }
                          return String(v);
                        };

                        return (
                          <tr key={field}>
                            <td>{field}</td>
                            <td>{format(oldRaw)}</td>
                            <td>{format(newRaw)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
                {data?.change === 'Added' && (
                  <table className='table table-striped'>
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(data?.diff || {}).map((key) => (
                        <tr key={key}>
                          <td>{key}</td>
                          <td>{data.diff[key] || '<empty>'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {data?.change === 'Deleted' && (
                  <table className='table table-striped'>
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(data?.diff || {}).map((key) => (
                        <tr key={key}>
                          <td>{key}</td>
                          <td>{data.diff[key] || '<empty>'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
            <hr />
            <div style={{ marginBottom: '20px' }}>
              <h4 className='modal-subtitle' style={{ fontWeight: 'bold' }}>
                Date Modified
              </h4>
              <p>{data?.datemodified || '<empty>'}</p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

// Audit Logs component
const AuditLogs = ({ getAuditLogs, auditLogs, showLoader }) => {
  const [auditLogsData, setAuditLogsData] = useState([]);
  // default to the current month-year
  const now = new Date();
  const currentMonthYear = `${now.toLocaleString('default', { month: 'long' })}-${now.getFullYear()}`;
  const [selectedPeriod, setSelectedPeriod] = useState(currentMonthYear);
  const [viewDetailsModal, setViewDetailsModal] = useState(false);
  const [viewDetailsModalData, setViewDetailsModalData] = useState(null);

  // filter state
  const [filterTable, setFilterTable] = useState(null);
  const [filterAuthor, setFilterAuthor] = useState(null);
  const [searchText, setSearchText] = useState('');

  // Periods to select
  const periods = [];
  const startYear = 2025;
  const startMonth = 0; // January
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  for (let year = startYear; year <= currentYear; year++) {
    const monthLimit = year === currentYear ? currentMonth : 11;
    for (let month = year === startYear ? startMonth : 0; month <= monthLimit; month++) {
      let date = new Date(year, month);
      periods.push({
        label: `${date.toLocaleString('default', { month: 'long' })}-${date.getFullYear()}`,
        value: `${date.toLocaleString('default', { month: 'long' })}-${date.getFullYear()}`,
      });
    }
  }

  // Fetch the audit logs data
  useEffect(() => {
    const fetchAuditLogs = async (period) => {
      let data = await getAuditLogs(period);
      return data;
    };
    const fetchData = async () => {
      setAuditLogsData([]);
      auditLogs = await fetchAuditLogs(selectedPeriod);
      setAuditLogsData(auditLogs);
    };
    fetchData();
  }, [selectedPeriod]);

  // derive filter options from the raw logs
  const filterOptions = useMemo(() => {
    const entries = auditLogsData?.logs?.data || [];
    return {
      tables: _.uniq(entries.map((e) => JSON.parse(e.message).table)).map((t) => ({ label: t, value: t })),
      authors: _.uniq(
        entries.map((e) => {
          const a = JSON.parse(e.message).author;
          return a.substring(0, a.indexOf('<'));
        })
      ).map((a) => ({ label: a, value: a })),
      itemIds: _.uniq(entries.map((e) => JSON.parse(e.message).itemId)).map((id) => ({ label: id, value: id })),
    };
  }, [auditLogsData]);

  // filter the list before rendering
  const displayedLogs = useMemo(() => {
    const entries = auditLogsData?.logs?.data || [];

    const hay = searchText.toLowerCase().trim();

    // 1) Filter
    const filtered = entries.filter((e) => {
      const msg = JSON.parse(e.message);
      const authorName = msg.author.substring(0, msg.author.indexOf('<'));

      // dropdown filters:
      if (filterTable && msg.table !== filterTable.value) return false;
      if (filterAuthor && authorName !== filterAuthor.value) return false;

      // global text search across all fields:
      if (hay) {
        const fields = [msg.table, authorName, msg.itemId, msg.change, msg.datemodified].map((f) => String(f).toLowerCase());

        // if none of them include our search substring, drop it:
        if (!fields.some((f) => f.includes(hay))) return false;
      }

      return true;
    });

    // 2) Sort newest first
    return filtered.sort((a, b) => {
      const da = new Date(JSON.parse(a.message).datemodified);
      const db = new Date(JSON.parse(b.message).datemodified);
      return db - da;
    });
  }, [auditLogsData, filterTable, filterAuthor, searchText]);

  return (
    <>
      <Breadcrumb items={items} />
      <div className='row'>
        <div className='col-lg-12'>
          <section className='panel'>
            <aside className='profile-nav alt'>
              <section className='panel'>
                <header
                  className='panel-heading'
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                  }}>
                  Audit Logs
                  <div style={{ display: 'flex' }}>
                    {/* Period */}
                    <Select
                      options={periods}
                      styles={adminPortalSelect}
                      value={periods.find((p) => p.value === selectedPeriod)}
                      onChange={(o) => setSelectedPeriod(o.value)}
                      placeholder='Period'
                    />

                    {/* Table */}
                    <Select
                      isClearable
                      options={filterOptions.tables}
                      value={filterTable}
                      onChange={setFilterTable}
                      styles={adminPortalSelect}
                      placeholder='TABLE'
                    />

                    {/* Author */}
                    <Select
                      isClearable
                      options={filterOptions.authors}
                      value={filterAuthor}
                      onChange={setFilterAuthor}
                      styles={adminPortalSelect}
                      placeholder='AUTHOR'
                    />

                    {/* Global Search */}
                    <div style={{ marginLeft: '1rem' }}>
                      <input
                        type='text'
                        placeholder='Search…'
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{
                          padding: '6px 8px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          width: '160px',
                        }}
                      />
                    </div>
                  </div>
                </header>

                <div className='panel-body'>
                  <div className='row'>
                    <div className='col-lg-12'>
                      <div className='row'>
                        <div className='col-lg-12'>
                          <table className='table table-striped'>
                            <thead>
                              <tr>
                                <th>Author</th>
                                <th>Date Modified</th>
                                <th>Change</th>
                                <th>Table</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Map through the audit logs data */}
                              {displayedLogs.map((log) => {
                                let message = JSON.parse(log.message);
                                let diff = message.diff;
                                let change = message.change;
                                let table = message.table;
                                let datemodified = message.datemodified;
                                let itemId = message.itemId;

                                // Format date
                                let date = new Date(datemodified);
                                datemodified = date.toLocaleString();

                                // Split author into name and ID
                                let author = message.author;
                                let authorName = author.substring(0, author.indexOf('<'));
                                let start = author.indexOf('<');
                                let end = author.indexOf('>');
                                let authorID = author.substring(start + 1, end);

                                return (
                                  <tr key={log.eventId}>
                                    <div style={{ cursor: 'pointer' }} className='admin_portal_cellData_description'>
                                      <Tooltip title={<p style={{ fontSize: 12, marginBottom: 0 }}>{authorID}</p>}>
                                        <p style={{ fontSize: 14, padding: 10 }}> {authorName} </p>
                                      </Tooltip>
                                    </div>
                                    <td>{datemodified}</td>
                                    <td>
                                      {change === 'Added' && <span className='label label-success'>Added</span>}
                                      {change === 'Deleted' && <span className='label label-danger'>Deleted</span>}
                                      {change === 'Updated' && <span className='label label-warning'>Updated</span>}
                                    </td>
                                    <td>{table}</td>
                                    <td>
                                      <AddButton
                                        onClick={() => {
                                          // Set the data for the view details modal
                                          setViewDetailsModalData({
                                            ...log,
                                            itemId,
                                            authorName,
                                            authorID,
                                            datemodified,
                                            diff,
                                            change,
                                            table,
                                          });
                                          setViewDetailsModal(true);
                                        }}>
                                        View Details
                                      </AddButton>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Show loader */}
                  {showLoader && (
                    <div
                      style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', paddingBottom: '50px' }}>
                      <Waveform size={40} lineWeight={3.5} speed={1} color='black' />
                    </div>
                  )}
                </div>
              </section>
            </aside>
          </section>
        </div>
      </div>
      {/* View Details Modal */}
      <ViewDetailsModal open={viewDetailsModal} handleClose={() => setViewDetailsModal(false)} data={viewDetailsModalData} />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auditLogs: state.admin?.auditLogs,
    showLoader: state.showLoader,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAuditLogs: (period) => dispatch(ADMINACTIONS.getAuditLogs(period)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditLogs, ViewDetailsModal);
